var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.347,
    height: 19.459,
    viewBox: "0 0 20.347 19.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(-142 -51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    transform: "translate(142 51)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x2: 4.654,
    y2: 4.654,
    transform: "translate(156.986 65.098)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.e2a2547e33aa603b39ffba2e51fe8008.svg";
export { ForwardRef as ReactComponent };